import React from 'react';
import { TYPE_ICONS, ATTRIBUTE_COLORS } from '../../utils/constants';
import { useBattle } from '../context';

/**
 * MobileCardDetailModal
 *
 * モバイル用カード詳細表示モーダル
 * - カードの全情報を表示
 * - タップで閉じる
 *
 * Props: なし（全て Context から取得）
 */
const MobileCardDetailModal: React.FC = () => {
  // Context から状態を取得
  const { mobileCardDetail, setMobileCardDetail } = useBattle();
  // mobileCardDetail が null の場合はレンダリングしない
  if (!mobileCardDetail) {
    return null;
  }

  // カードデータを取得
  const card = mobileCardDetail.card;

  const handleClose = () => {
    setMobileCardDetail(null);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.9)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1100,
        padding: '16px',
      }}
      onClick={handleClose}
    >
      <div
        style={{
          background: 'linear-gradient(135deg, #1a1a3a 0%, #2a2a4a 100%)',
          borderRadius: '12px',
          padding: '16px',
          maxWidth: '90%',
          maxHeight: '90%',
          overflow: 'auto',
          border: '2px solid rgba(107,76,230,0.5)',
          boxShadow: '0 0 30px rgba(107,76,230,0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* ヘッダー */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '12px',
          borderBottom: '1px solid rgba(107,76,230,0.3)',
          paddingBottom: '8px',
        }}>
          <h3 style={{ margin: 0, color: '#e0e0e0', fontSize: '16px' }}>
            {TYPE_ICONS[card.type]} {card.name}
          </h3>
          <button
            onClick={handleClose}
            style={{
              background: 'rgba(255,255,255,0.1)',
              border: 'none',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              color: '#fff',
              fontSize: '18px',
              cursor: 'pointer',
            }}
          >
            ✕
          </button>
        </div>

        {/* カード情報 */}
        <div style={{ fontSize: '13px', color: '#c0c0c0' }}>
          {/* 基本情報 */}
          <div style={{
            display: 'flex',
            gap: '12px',
            marginBottom: '12px',
            flexWrap: 'wrap',
          }}>
            <span style={{
              background: ATTRIBUTE_COLORS[card.attribute]?.bg || 'rgba(100,100,100,0.3)',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
            }}>
              {card.attribute}属性
            </span>
            <span style={{
              background: 'rgba(107,76,230,0.3)',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
            }}>
              コスト: {card.cost}
            </span>
            {card.type === 'monster' && (
              <>
                <span style={{
                  background: 'rgba(255,107,107,0.3)',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                }}>
                  ATK: {card.attack}
                </span>
                <span style={{
                  background: 'rgba(107,255,107,0.3)',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                }}>
                  HP: {card.hp}
                </span>
              </>
            )}
          </div>

          {/* カテゴリ */}
          {card.category && (
            <div style={{ marginBottom: '8px', color: '#9c6bff' }}>
              {card.category}
            </div>
          )}

          {/* 効果テキスト */}
          {card.effect && (
            <div style={{
              background: 'rgba(0,0,0,0.3)',
              padding: '12px',
              borderRadius: '8px',
              lineHeight: '1.6',
              whiteSpace: 'pre-wrap',
              marginBottom: '8px',
            }}>
              {card.effect}
            </div>
          )}

          {/* 技情報（モンスターのみ） */}
          {card.type === 'monster' && (
            <div style={{ marginTop: '12px' }}>
              {card.basicSkill && (
                <div style={{
                  background: 'rgba(76,175,80,0.2)',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  marginBottom: '8px',
                  borderLeft: '3px solid #4caf50',
                }}>
                  <div style={{ fontWeight: 'bold', color: '#4caf50', marginBottom: '4px' }}>
                    基本技 (コスト: {card.basicSkill.cost})
                  </div>
                  <div style={{ fontSize: '12px' }}>{card.basicSkill.text}</div>
                </div>
              )}
              {card.advancedSkill && (
                <div style={{
                  background: 'rgba(255,152,0,0.2)',
                  padding: '8px 12px',
                  borderRadius: '6px',
                  borderLeft: '3px solid #ff9800',
                }}>
                  <div style={{ fontWeight: 'bold', color: '#ff9800', marginBottom: '4px' }}>
                    上級技 (コスト: {card.advancedSkill.cost})
                  </div>
                  <div style={{ fontSize: '12px' }}>{card.advancedSkill.text}</div>
                </div>
              )}
            </div>
          )}

          {/* フレーバーテキスト */}
          {card.flavor && (
            <div style={{
              marginTop: '12px',
              fontStyle: 'italic',
              color: '#888',
              fontSize: '11px',
              borderTop: '1px solid rgba(107,76,230,0.2)',
              paddingTop: '8px',
            }}>
              {card.flavor}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileCardDetailModal;
